import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class PersonalSpendLimitProp extends Vue {
  @Prop({ required: false, default: false }) isSpendLimitInsufficient!: boolean;
}
